import { type GraphViewRequestBodyBase, isNonNullable } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import type { GraphData } from 'components/Graph/model/GraphData';

export const applyCollapsedNodeGroupsToViewRequestBody = (
  graph: GraphData,
  body: Omit<GraphViewRequestBodyBase, 'collapsedNodeGroups'>,
): GraphViewRequestBodyBase => ({
  ...body,
  collapsedNodeGroups: Object.values(graph.collapsedNodeGroups).map(
    (group) => ({
      position: graph.nodes[group.id]?.position ?? { x: 0, y: 0 },
      nodeSns: Object.values(group.nodes).filter(isNonNullable).map(prop('sn')),
    }),
  ),
});
